/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisputeResultBody
 */
export interface DisputeResultBody {
    /**
     * Reason for disputing the result
     * @type {string}
     * @memberof DisputeResultBody
     */
    reason: string;
    /**
     * URLs to evidence (screenshots, videos, etc.)
     * @type {Array<string>}
     * @memberof DisputeResultBody
     */
    evidence?: Array<string>;
}

/**
 * Check if a given object implements the DisputeResultBody interface.
 */
export function instanceOfDisputeResultBody(value: object): value is DisputeResultBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DisputeResultBodyFromJSON(json: any): DisputeResultBody {
    return DisputeResultBodyFromJSONTyped(json, false);
}

export function DisputeResultBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeResultBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'evidence': json['evidence'] == null ? undefined : json['evidence'],
    };
}

export function DisputeResultBodyToJSON(json: any): DisputeResultBody {
    return DisputeResultBodyToJSONTyped(json, false);
}

export function DisputeResultBodyToJSONTyped(value?: DisputeResultBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'evidence': value['evidence'],
    };
}

